var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSofa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Sofa",
    transform: "translate(-253 -71)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-icon",
    width: 32,
    height: 32,
    transform: "translate(253 71)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "armchair",
    transform: "translate(253 72.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M28.064,29H24.007a.526.526,0,0,1-.533-.518v-1.4H8.526v1.4A.526.526,0,0,1,7.993,29H3.936a.526.526,0,0,1-.533-.518V26.943a2.278,2.278,0,0,1-1.53-2.126V19.189A3.884,3.884,0,0,1,0,15.875a3.992,3.992,0,0,1,4.044-3.929,4.143,4.143,0,0,1,.969.115V5.874A5.968,5.968,0,0,1,11.059,0h9.882a5.969,5.969,0,0,1,6.046,5.874v6.187a4.178,4.178,0,0,1,.969-.115A3.992,3.992,0,0,1,32,15.875a3.884,3.884,0,0,1-1.872,3.314v5.627a2.277,2.277,0,0,1-1.53,2.126v1.539A.526.526,0,0,1,28.064,29Zm-3.523-1.92v.884h2.99V27.08Zm-20.072,0v.884h2.99V27.08Zm23.487-14.1a2.939,2.939,0,0,0-2.977,2.893V26.044H27.8a1.247,1.247,0,0,0,1.264-1.228v-5.9a.358.358,0,0,1,0-.041.519.519,0,0,1,.283-.438,2.878,2.878,0,0,0,1.589-2.559A2.939,2.939,0,0,0,27.956,12.982ZM8.088,24.158v1.886H23.912V24.158ZM4.044,12.982a2.939,2.939,0,0,0-2.977,2.893,2.878,2.878,0,0,0,1.589,2.559.519.519,0,0,1,.284.437.394.394,0,0,1,0,.049v5.9A1.247,1.247,0,0,0,4.2,26.044H7.021V15.875A2.939,2.939,0,0,0,4.044,12.982Zm4.044,5.493v4.646H23.912V18.476ZM11.059,1.036A4.916,4.916,0,0,0,6.079,5.874v6.608a4.012,4.012,0,0,1,1.454,1.41,3.83,3.83,0,0,1,.554,1.982v1.564H23.912V15.875a3.83,3.83,0,0,1,.554-1.982,4.027,4.027,0,0,1,1.454-1.41V5.874a4.916,4.916,0,0,0-4.979-4.838Z",
    transform: "translate(0 -0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.985,1.97a.985.985,0,0,0,.7-1.683.988.988,0,0,0-1.394,0,.986.986,0,0,0,.7,1.683Z",
    transform: "translate(9.595 4.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.985,1.97a.985.985,0,0,0,.7-1.683.988.988,0,0,0-1.394,0,.986.986,0,0,0,.7,1.683Z",
    transform: "translate(14.802 4.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.985,1.97a.985.985,0,0,0,.7-1.683.988.988,0,0,0-1.394,0,.986.986,0,0,0,.7,1.683Z",
    transform: "translate(20.008 4.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M.985,1.97a.985.985,0,0,0,.7-1.683.988.988,0,0,0-1.394,0,.986.986,0,0,0,.7,1.683Z",
    transform: "translate(9.595 10.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M.985,1.97a.985.985,0,0,0,.7-1.683.988.988,0,0,0-1.394,0,.986.986,0,0,0,.7,1.683Z",
    transform: "translate(14.802 10.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M.985,1.97a.985.985,0,0,0,.7-1.683.988.988,0,0,0-1.394,0,.986.986,0,0,0,.7,1.683Z",
    transform: "translate(20.008 10.781)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.3a4c1d0af5a708a5a6b51b4de14fa4da.svg";
export { ForwardRef as ReactComponent };